export default __webpack_public_path__ + "static/media/char_body_prem_004.4814a5b2.png";